import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function HomePage() {
  const navigate = useNavigate()
  const { user, isLoading } = useAuth()

  useEffect(() => {
    if (!isLoading) {
      if (!user) {
        navigate('/login')
      } else if (user.firstimeSetup === 0) {
        navigate('/onboarding')
      } else {
        navigate('/dashboard')
      }
    }
  }, [user, isLoading, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
      <div className="animate-pulse flex flex-col items-center">
        <div className="h-16 w-16 rounded-xl bg-gray-900 dark:bg-gray-100 flex items-center justify-center text-white dark:text-gray-900 font-bold text-2xl shadow-lg">
          B
        </div>
        <h2 className="mt-6 text-xl font-medium text-gray-700 dark:text-gray-300">Loading...</h2>
      </div>
    </div>
  )
}
